import { Chip, withStyles } from "@material-ui/core";

const VerifiedStatusChip = withStyles({
  root: {
    height: "24px",
    '&[data-status="success"]': {
      backgroundColor: "#D2F0CD",
      color: "#244220",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="danger"]': {
      backgroundColor: "#ffadb5",
      color: "#833D3D",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="warn"]': {
      backgroundColor: "#ffd2a5",
      color: "#833D3D",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="danger-dark"]': {
      backgroundColor: "transparent",
      color: "#be4408",
      fontFamily: "Mulish",
      textTransform: "capitalize",
      borderRadius: 4,
      border: "1px solid #be4408 !important",
    },
    '&[data-status="danger-outlined"]': {
      backgroundColor: "transparent",
      color: "#be4408",
      fontFamily: "Mulish",
      textTransform: "capitalize",
      borderRadius: 4,
      border: "1px solid #be4408 !important",
    },
    '&[data-status="success-outlined"]': {
      backgroundColor: "transparent",
      color: "#0028fa",
      fontFamily: "Mulish",
      textTransform: "capitalize",
      borderRadius: 4,
      border: "1px solid #0028fa !important",
    },
    '&[data-status="success-outlined-sm"]': {
      backgroundColor: "transparent",
      color: "#0028fa",
      fontFamily: "Mulish",
      textTransform: "capitalize",
      borderRadius: 4,
      border: "1px solid #0028fa !important",
      fontSize: 12,
      padding: 0,
    },
    '&[data-status="light"]': {
      backgroundColor: "rgb(237 244 255)",
      color: "#4d4d4d",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="primary"]': {
      backgroundColor: "#0028fa",
      color: "#fff",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="dark"]': {
      backgroundColor: "#16191f",
      color: "#fff",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="profile-input"]': {
      backgroundColor: "rgb(237 244 255)",
      color: "#16191f",
      fontFamily: "Mulish",
      textTransform: "capitalize",
      borderRadius: 4,
      height: "38px",
      fontWeight: 600,
    },
    '&[data-status="profile-warn"]': {
      backgroundColor: "#ffd2a5",
      color: "#833D3D",
      fontFamily: "Mulish",
      textTransform: "capitalize",
      borderRadius: 4,
      height: "38px",
      fontWeight: 600,
    },
    '&[data-status="Prospecting"]': {
      backgroundColor: "#C5E3FF",
      color: "#244220",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="First Contact"]': {
      backgroundColor: "#9CD0FF",
      color: "#244220",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="Viewing"]': {
      backgroundColor: "#f5d6b6",
      color: "#244220",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="Viewing Outcome"]': {
      backgroundColor: "#FFB800",
      color: "#244220",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="Assessment"]': {
      backgroundColor: "#a9d7bb",
      color: "#244220",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="Assessment Outcome"]': {
      backgroundColor: "#70BB63",
      color: "#244220",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[data-status="Closed"]': {
      backgroundColor: "#C4C4C4",
      color: "#244220",
      fontFamily: "Mulish",
      textTransform: "capitalize",
    },
    '&[text-style="info"]': {
      textTransform: "initial",
    },
  },
})(Chip);
export default VerifiedStatusChip;
